module.exports = __webpack_public_path__ + "static/media/creativeshead.696901e9.jpg";